(() => {
  const selector = {
    slider: '.product-recommendations__content--slider',
    recommendationsSection: '.product-recommendations',
    addToCartHandler: '.js-add-to-cart',
    trustpilotWidget: '.trustpilot-widget',
    recommendationItem: '.product-recommendations__item',

    recommendationItemHideClass: 'product-recommendations__item--hidden',
  }

  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;

          const recommendationsSection = this.closest(selector.recommendationsSection);

          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }

              if (+html.querySelector('.product-recommendations__content').dataset.size <= 0) {
                recommendationsSection.style.display = 'none';
              }

              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }

              const sliderElement = this.querySelector(selector.slider);
              const addToCartHandlers = this.querySelectorAll(selector.addToCartHandler);
              const trustpilotWidgets = this.querySelectorAll(selector.trustpilotWidget);

              trustpilotWidgets.forEach((widget) => {
                window.Trustpilot.loadFromElement(widget);
              });

              const slickSettings = {
                infinite: false,
                dots: this.querySelectorAll(selector.recommendationItem).length > 2,
                arrows: false,
                autoplay: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                mobileFirst: true,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                      dots: this.querySelectorAll(selector.recommendationItem).length > 4,
                    }
                  },
                ],
              };

              if (sliderElement && typeof $.fn.slick === 'function') {
                $(sliderElement).slick(slickSettings);
              }

              addToCartHandlers.forEach((handler) => {
                handler.addEventListener('click', (e) => {
                  window.handlers['addProduct'](e.currentTarget.dataset.id);
                });
              });
            })
            .catch(e => {
              console.error(e);
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
      }
    }

    customElements.define('product-recommendations', ProductRecommendations);
  }
})();
